import RemindAPI from 'lib/RemindAPI';
import ToastActions from 'actions/ToastActions';
import CLAIM_DEVICE from 'user/mutations/ClaimDevice.gql';
import CLAIM_ACCOUNT_SCREEN from 'user/queries/ClaimAccountScreen.gql';
import { ClaimAccountScreen } from 'user/queries/__generated__/ClaimAccountScreen';
import { ClaimDevice, ClaimDeviceVariables } from 'user/mutations/__generated__/ClaimDevice';
import VERIFY_DEVICE_FOR_ACCOUNT_MERGE from 'user/mutations/VerifyDeviceForAccountMerge.gql';
import {
  VerifyDeviceForAccountMerge,
  VerifyDeviceForAccountMergeVariables,
} from 'user/mutations/__generated__/VerifyDeviceForAccountMerge';

export function verifyDeviceCode(address: string, code: string) {
  return RemindAPI.execute<VerifyDeviceForAccountMerge, VerifyDeviceForAccountMergeVariables>({
    mutation: VERIFY_DEVICE_FOR_ACCOUNT_MERGE,
    variables: { input: { address, code } },
  }).catch((err) => {
    console.warn(err);
    console.error(`User Actions - could not verify device code address=${address} code=${code}`);
    ToastActions.showGQLError(err);
  });
}

export function getClaimAccountScreen(claimToken: string) {
  return RemindAPI.execute<ClaimAccountScreen>({
    query: CLAIM_ACCOUNT_SCREEN,
    variables: { input: { claimToken } },
  }).catch((err) => {
    console.warn(err);
    console.error(`User Actions - could not get claim account screen claim_token=${claimToken}`);
  });
}

export function claimDevice(claimToken: string, mergeAccounts: boolean) {
  return RemindAPI.execute<ClaimDevice, ClaimDeviceVariables>({
    mutation: CLAIM_DEVICE,
    variables: { input: { claimToken, mergeAccounts } },
  }).catch((err) => {
    console.warn(err);
    const mergeAccountsString = mergeAccounts ? 'yes' : 'no';
    console.error(
      `User Actions - could not claim device claim_token=${claimToken} merge_accounts=${mergeAccountsString}`
    );
    ToastActions.showGQLError(err);
  });
}
